<div class="astrea-clients">

    <div class="slider-clientes">
        <div class="slide-track-clientes">

            <!-- AJUSTAR LENGTH EN SCSS -->

            <a *ngFor="let c of clients" [href]="c.url" target="_blank" class="item-clientes">
                <img class="img-responsive" [src]="c.image" [alt]="c.name" />
            </a>

        </div>
    </div>

</div>
